import "../styles/globals.css";
import Head from "next/head";
import { useRouter } from "next/router";
import dynamic from "next/dynamic";
const CookieConsent = dynamic(() => import("../components/CookieConsent"), {
  ssr: false,
});
const FloatingContactButton = dynamic(
  () => import("../components/services/FloatingContactButton"),
  { ssr: false }
);

function MyApp({ Component, pageProps }) {
  const router = useRouter();
  const blogRoute = pageProps.noAutoHeader != "no";
  return (
    <>
      <Head>
        <link rel="icon" type="image/svg" href="/favicon.svg" sizes="16x16" />

        {/* Page-specific description or fallback */}
        {Component?.desc ? (
          <meta name="description" content={Component.desc} />
        ) : (
          <meta
            name="description"
            content="Enterprise Tech Solutions India, Innovative Tech India, IT Strategy Consulting India, Tech Efficiency India, Secure Digital Infrastructure India, Digital Solutions India, Tailored Software India, AI Services India, Cloud Consulting India, Cybersecurity Solutions India."
          />
        )}

        {/* Page-specific keywords or fallback */}
        {Component?.keywords ? (
          <meta name="keywords" content={Component.keywords} />
        ) : (
          <meta
            name="keywords"
            content="Enterprise Tech Solutions India, Innovative Tech India, IT Strategy Consulting India, Tech Efficiency India, Secure Digital Infrastructure India, Digital Solutions India, Tailored Software India, AI Services India, Cloud Consulting India, Cybersecurity Solutions India"
          />
        )}

        <meta property="og:type" content="website" />
        {Component?.title && <meta property="og:title" content={Component.title} />}
        {Component?.desc && <meta property="og:description" content={Component.desc} />}
        {Component?.header_img && <meta property="og:image" content={Component.header_img} />}
        {router?.asPath && <meta property="og:url" content={`https://www.itmtb.com${router.asPath}`} />}
        
        {blogRoute && <meta name="author" content="itmtb team" />}
        {blogRoute && <meta name="twitter:card" content="summary_large_image" />}
        {Component?.desc && <meta name="twitter:description" content={Component.desc} />}
        {Component?.title && <meta name="twitter:title" content={Component.title} />}
        {blogRoute && <meta name="twitter:site" content="@ItmtbT" />}
        {Component?.header_img && <meta name="twitter:image" content={Component.header_img} />}
        {Component?.title && <title>{Component.title}</title>}

        {router?.asPath && (
          <link
            rel="canonical"
            href={`https://www.itmtb.com${router.asPath.split("?")[0]}`}
          />
        )}

        {Component?.faq?.length > 0 && (
          <script
            type="application/ld+json"
            dangerouslySetInnerHTML={{
              __html: JSON.stringify({
                "@context": "https://schema.org",
                "@type": "FAQPage",
                mainEntity: Component.faq.map(item => ({
                  "@type": "Question",
                  name: item.q,
                  acceptedAnswer: { "@type": "Answer", text: item.a },
                })),
              }),
            }}
          />
        )}

        {router?.pathname === "/" && (
          <script
            type="application/ld+json"
            dangerouslySetInnerHTML={{
              __html: JSON.stringify({
                "@context": "https://schema.org",
                "@type": "Organization",
                name: "ITMTB",
                url: "https://www.itmtb.com",
                logo: "https://www.itmtb.com/logo.png",
                description:
                  "Enterprise AI and software delivery company. We build, deploy, and manage AI agents, cloud infrastructure, cybersecurity, data platforms, and enterprise applications for businesses in India and globally.",
                hasCredential: {
                  "@type": "EducationalOccupationalCredential",
                  credentialCategory: "DPIIT Recognition — Startup India",
                  identifier: "DIPP274362",
                  recognizedBy: {
                    "@type": "GovernmentOrganization",
                    name: "Department for Promotion of Industry and Internal Trade (DPIIT), Government of India",
                  },
                },
                sameAs: [
                  "https://www.linkedin.com/company/itmtb",
                  "https://twitter.com/ItmtbT",
                ],
                contactPoint: {
                  "@type": "ContactPoint",
                  contactType: "sales",
                  url: "https://www.itmtb.com/contact-us",
                },
              }),
            }}
          />
        )}

      </Head>


      <Component {...pageProps} />
      <FloatingContactButton />
      <CookieConsent />
    </>
  );
}

export default MyApp;
